/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ServiceCharges {
    "use strict";

    export class ServiceChargesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        public criteriaForCoBtChange: any = {};
        public updatedBusinessTypeId: any;
        public smartMoverCriteria: any = {};
        public coCriteria: any = {};

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            timeoutService: angular.ITimeoutService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.baseEndpoint = appSettings.API_ENDPOINTS.serviceCharges;
            this.sectionTemplatePath = "app/plugins/serviceCharges/sectionViews/";
            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeys(this.securityKeys.BUSINESSINFO_SERVICECHARGES_TAB_MAIN);
            this.entityType = 'ServiceCharges';
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_SERVICECHARGES_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.serviceCharges, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ServiceChargesMain, null, this.securityKeys.BUSINESSINFO_SERVICECHARGES_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        getCreteria(): any {
            this.smartMoverCriteria = {};
            if (this.identityService.inCentralOfficeMode() && this.selectedSection.model.homeLocationId == this.identityService.current().centralOfficeId && Model.Guard.isSomething(this.selectedSection.model) && Model.Guard.isNothing(this.smartMoverCriteria)) {

                this.smartMoverCriteria =
                    {
                        coSearchType: 0,
                        coBusinessTypeId: this.identityService.current().tenantData.allBusinessTypeId == this.selectedSection.model.businessTypeDetail.id ? null : this.selectedSection.model.businessTypeDetail.id
                    }
            }
            return this.smartMoverCriteria;
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.ServiceCharges>();
            model.displayName = undefined;
        }


        onBusinessTypeChange(): void {

            //ToDO : on business type change reload the service mover
            if (Model.Guard.isSomething(this.selectedSection.model) && Model.Guard.isSomething(this.selectedSection.model.businessTypeDetail) && this.identityService.inCentralOfficeMode()) {
                this.coCriteria =
                    {
                        coSearchResultFilter: 0, coSearchType: 0,
                        coBusinessTypeId: this.identityService.current().tenantData.allBusinessTypeId == this.selectedSection.model.businessTypeDetail.id ? null : this.selectedSection.model.businessTypeDetail.id
                    };
            }
        }

        isTicketCharge(model) {
            if (!model) {
                return false;
            }
            
            return model.chargeTypeEnum === Meevo.Model.ChargeTypeEnum.TicketCharge;
        }

        onChargeTypeChanged(): void {
            if (!this.selectedSection.model) {
                return;
            }

            let model: any = this.selectedSection.model;

            if (this.isTicketCharge(model)) {
                model.isPercent = false;
            }
        }

        save(): angular.IPromise<any> {
            const model = this.selectedSection.model as Meevo.Model.ServiceCharges;
            if (this.takeOwnership) {
                this.selectedSection.model["taxItem_LId"] = null;
            }
          return super.save();
        }
    }
}